<template>
  <div class="flex items-center gap-4">
    <!-- Filtro de Status -->
    <div class="relative">
      <select
        v-model="selectedStatus"
        @change="emitFilters"
        class="appearance-none bg-white pl-8 pr-4 py-2 rounded-xl border border-gray-200 text-sm text-[#4A4453] focus:outline-none cursor-pointer min-w-[120px] hover:border-[#FF5722] transition-colors"
      >
        <option value="all">{{ $t("vendings.filterAll") }}</option>
        <option value="online">{{ $t("vendings.filterOnline") }}</option>
        <option value="offline">{{ $t("vendings.filterOffline") }}</option>
      </select>
      <span
        class="material-icons text-[#FF5722] text-sm absolute left-2.5 top-1/2 -translate-y-1/2"
        >filter_list</span
      >
    </div>

    <!-- Ordenação -->
    <div class="relative">
      <select
        v-model="sortOrder"
        @change="emitFilters"
        class="appearance-none bg-white pl-8 pr-4 py-2 rounded-xl border border-gray-200 text-sm text-[#4A4453] focus:outline-none cursor-pointer min-w-[150px] hover:border-[#FF5722] transition-colors"
      >
        <option value="newest">{{ $t("vendings.sortNewest") }}</option>
        <option value="oldest">{{ $t("vendings.sortOldest") }}</option>
      </select>
      <span
        class="material-icons text-[#FF5722] text-sm absolute left-2.5 top-1/2 -translate-y-1/2"
        >sort</span
      >
    </div>
  </div>
</template>

<script lang="js">
export default {
  props: {
    filters: {
      type: Object,
      default: () => ({
        status: 'all',
        sort: 'newest'
      })
    }
  },

  data() {
    return {
      selectedStatus: this.filters.status || 'all',
      sortOrder: this.filters.sort || 'newest'
    }
  },

  methods: {
    emitFilters() {
      this.$emit('update:filters', {
        status: this.selectedStatus,
        sort: this.sortOrder
      })
    }
  },

  watch: {
    selectedStatus() {
      this.emitFilters()
    },
    sortOrder() {
      this.emitFilters()
    },
    filters: {
      handler(newFilters) {
        this.selectedStatus = newFilters.status;
        this.sortOrder = newFilters.sort;
      },
      deep: true
    }
  },

  mounted() {
    // Emitir valores iniciais
    this.emitFilters()
  }
}
</script>

<style scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

select::-ms-expand {
  display: none;
}
</style>
